import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2Proveedor } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const ProveedorFormGroup = ({ razonSocialSocio, limpiarDatos, asignarDatos }) => {
  const onChangeSocioHandler = React.useCallback(
    pickedMember => {
      asignarDatos({
        _idSocio: pickedMember.value,
        razonSocial: pickedMember.label
      })
    },
    [asignarDatos]
  )

  const clickClear = React.useCallback(() => {
    limpiarDatos()
  }, [limpiarDatos])

  return (
    <Form.Group>
      <Form.Label text='PROVEEDOR' md={12} alignRightAt='md' />
      <Col md={12}>
        {razonSocialSocio ? (
          <ClearInputGroup id='codigoRucSocio' iValue={razonSocialSocio} clickClear={clickClear} />
        ) : (
          <Select2Proveedor id='codigoRucSelect' onChange={onChangeSocioHandler} />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProveedorFormGroup)
